import { serverMessage } from '@/Ship/Helpers/serverError'

/**
 * Текст відмови бека для повідомлення поза формою.
 *
 * На 422 бек віддає `violations` по полях, а в `message` склеює їх із назвою
 * поля («name: У цій папці вже є…»). У спливному повідомленні назва поля
 * читається як технічний слід, тож спершу беремо самі тексти порушень, далі —
 * звичайне пояснення сервера (той самий прийом, що `departmentErrorText`).
 */
export const diskErrorText = (error: unknown, fallback: string): string => {
    const response = (error as { response?: unknown } | null)?.response
    const violations = (response as { violations?: unknown } | null | undefined)?.violations

    if (Array.isArray(violations)) {
        const lines = violations
            .map((violation) => (violation as { message?: unknown } | null)?.message)
            .filter((text): text is string => typeof text === 'string' && text.trim() !== '')

        if (lines.length > 0) return [...new Set(lines)].join(' ')
    }

    return serverMessage(error, fallback)
}
